import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ColorsTheme } from '../Theme';

export const smallLinkCss = css`
  font-size: 0.8rem;
  color: ${ColorsTheme.darkRedDefault};
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
  text-decoration-thickness: 0.5px;

`;

export const SmallLink = styled.a`
  ${smallLinkCss}
`;